import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=332bb49d&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=332bb49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bb49d",
  null
  
)

export default component.exports